import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import SupplierOrderReviewIndexPage from '../containers/SupplierOrderReviews'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const SupplierOrderReviewsPage = ({
  location,
	match
}) => {
  const dispatch = useDispatch()
	const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
	const { pathname } = location

	useEffect(() => {
		if (current[0] !== 'supplier_order_reviews') {
			dispatch(changeCurrent(['supplier_order_reviews']))
		}
	}, [pathname])

	const path = match.url

  return (
		<Switch>
			<Route path={`${path}/`} component={SupplierOrderReviewIndexPage} exact />
		</Switch>
  )
}

SupplierOrderReviewsPage.propTypes = {
  location: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired
}

SupplierOrderReviewsPage.defaultProps = {}

export default SupplierOrderReviewsPage
